import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import reducers from './reducers/reducers'
//containers
import Navbar from './containers/navbar/NavBar';
import Footer from './containers/footer/Footer';
//Routes
import Landing from './routes/Landing';
import Products from './routes/Products';
import Industries from './routes/Industries';
import HomeandOffice from './routes/HomeandOffice';
import Automotive from './routes/Automotive';
import Health from './routes/Health';
import Informative from './routes/Informative';
import Outdoor from './routes/Outdoor';
import Intelligence from './routes/Intelligence';
import Pricing from './routes/Pricing';
import Developers from './routes/Developers';
import HelpAndGuides from './routes/HelpAndGuides';
import HowToGetAircheckrToken from './routes/help-and-guides/HowToGetAircheckrToken';
import FirstStepsWithTheAircheckrApi from './routes/help-and-guides/FirstStepsWithTheAircheckrApi';
import WhatAirQualityInfoCanIGet from './routes/help-and-guides/WhatAirQualityInfoCanIGet';
import AircheckrNewsletter from './routes/help-and-guides/AircheckrNewsletter';
import WhatIsAirPollution from './routes/help-and-guides/WhatIsAirPollution';
import TheSilentKiller from './routes/help-and-guides/TheSilentKiller';
import AirPollutionAndTheCurse from './routes/help-and-guides/AirPollutionAndTheCurse';
import IsAirQualityVaryingALot from './routes/help-and-guides/IsAirQualityVaryingALot';
import DoMyCustomersWantAirQualityInfo from './routes/help-and-guides/DoMyCustomersWantAirQualityInfo';
import ThereIsHope from './routes/help-and-guides/ThereIsHope';
import WhyHealthBased from './routes/help-and-guides/WhyHealthBased';
import PersonalisedRecommendations from './routes/help-and-guides/PersonalisedRecommendations';
import WhatWithLongTermEffect from './routes/help-and-guides/WhatWithLongTermEffect';
import TheBestAvailableAqInfo from './routes/help-and-guides/TheBestAvailableAqInfo';
import Status from './routes/help-and-guides/Status';
import AirQualityIndex from './routes/help-and-guides/AirQualityIndex';
import HighlyValidated from './routes/help-and-guides/HighlyValidated';
import DifferenceBetweenAqiAndAqComparison from './routes/help-and-guides/DifferenceBetweenAqiAndAqComparison';
import OurStory from './routes/OurStory';
import Team from './routes/Team';
import PressKit from './routes/PressKit';
import Pers from './routes/Pers';
import Contact from './routes/Contact';
import Signup from './routes/Signup';
import Auth from './containers/Auth';
import Confirm from './routes/Confirm';
import ResetPass from './routes/ResetPass';
import NoMatch from './routes/NoMatch';
//scroll handler
import ScrollToTop from './helpers/ScrollToTop';
//css
import 'bootstrap/dist/css/bootstrap.css';
import './index.styl';

class App extends React.Component {
  render(){
    return (
      <Router>
        <Provider store={ createStore(reducers) }>
          <ScrollToTop>
            <div className="page-wrapper">
              <Navbar />
              <Switch>
                <Route exact path='/' render={ () => <Landing lang='en' /> } />
                <Route exact path='/nl' render={ () => <Landing lang='nl' /> } />
                <Route exact path='/products' render={ () => <Products lang='en' /> } />
                <Route exact path='/nl/products' render={ () => <Products lang='nl' /> } />
                <Route exact path='/industries' render={ () => <Industries lang='en' /> } />
                <Route exact path='/nl/industries' render={ () => <Industries lang='nl' /> } />
                  <Route exact path='/industries/homeandoffice' component={HomeandOffice} />
                  <Route path='/industries/info' component={Informative} />
                  <Route path='/industries/outdoor' component={Outdoor} />
                  <Route exact path='/industries/health' component={Health} />
                  <Route exact path='/industries/auto' component={Automotive} />
                  <Route path='/industries/intelli' component={Intelligence} />
                <Route path='/pricing' render={ () => <Pricing lang='en' /> } />
                <Route path='/nl/pricing' render={ () => <Pricing lang='nl' /> } />
                <Route path='/developers' render={ () => <Developers lang='en' /> } />
                <Route path='/nl/developers' render={ () => <Developers lang='nl' /> } />
                <Route exact path='/help-and-guides' component={HelpAndGuides} />
                  <Route exact path='/help-and-guides/how-to-get-an-aircheckr-access-token' component={HowToGetAircheckrToken} />
                  <Route exact path='/help-and-guides/first-steps-with-the-aircheckr-api' component={FirstStepsWithTheAircheckrApi} />
                  <Route exact path='/help-and-guides/what-air-quality-info-can-i-get' component={WhatAirQualityInfoCanIGet} />
                  <Route exact path='/help-and-guides/airchecker-newsletter' component={AircheckrNewsletter} />
                  <Route exact path='/help-and-guides/what-is-air-pollution' component={WhatIsAirPollution} />
                  <Route exact path='/help-and-guides/the-silent-killer' component={TheSilentKiller} />
                  <Route exact path='/help-and-guides/air-pollution-and-the-curse' component={AirPollutionAndTheCurse} />
                  <Route exact path='/help-and-guides/is-air-quality-varying-a-lot' component={IsAirQualityVaryingALot} />
                  <Route exact path='/help-and-guides/do-my-customers-really-want-air-quality-info' component={DoMyCustomersWantAirQualityInfo} />
                  <Route exact path='/help-and-guides/there-is-hope' component={ThereIsHope} />
                  <Route exact path='/help-and-guides/why-health-based' component={WhyHealthBased} />
                  <Route exact path='/help-and-guides/personalised-recommendations' component={PersonalisedRecommendations} />
                  <Route exact path='/help-and-guides/what-with-long-term-effect' component={WhatWithLongTermEffect} />
                  <Route exact path='/help-and-guides/the-best-available-aq-info' component={TheBestAvailableAqInfo} />
                  <Route exact path='/help-and-guides/status' component={Status} />
                  <Route exact path='/help-and-guides/air-quality-index' component={AirQualityIndex} />
                  <Route exact path='/help-and-guides/highly-validated' component={HighlyValidated} />
                  <Route exact path='/help-and-guides/difference-between-aqi-and-aq-comparison' component={DifferenceBetweenAqiAndAqComparison} />
                <Route path='/our-story' component={OurStory} />
                <Route path='/team' component={Team} />
                <Route path='/press' component={PressKit} />
                <Route path='/pers' component={Pers} />
                <Route path='/contact' component={Contact} />
                <Route path='/signup' component={Signup} />
                <Route path='/login' component={Auth} />
                <Route path='/resetpass' component={ResetPass} />
                <Route path='/dashboard' component={Auth} />
                <Route path='/confirm' component={Confirm} />
                <Route component={NoMatch} />
              </Switch>
              <Footer />
            </div>
          </ScrollToTop>
        </Provider>
      </Router>
    );
  }
};

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js